/* eslint-disable max-len */
import { Component, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantService } from 'src/app/services/api/tenant.service';
import { translate } from '@jsverse/transloco';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Subscription } from 'rxjs';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { ClipboardService } from 'ngx-clipboard';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions, Datazone, Attributes} from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';

const REQUIRED_PERMISSIONS = [
  { 
    key: PermissionKeys.TENANT_READ,
    action: Permissions.TENANT_READ
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
    selector: 'app-subscription-mgmt-list',
    templateUrl: './subscription-mgmt-list.component.html',
    styleUrls: ['./subscription-mgmt-list.component.scss'],
    standalone: false
})
export class SubscriptionMgmtListComponent  implements OnInit {
  @ViewChild(MatSort, { static: true }) sort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
private destroyRef = inject(DestroyRef);

  DeployStatus = DeployStatus;
  breadcrumbItems: BreadcrumbItem[];

  tenant: string;
  susbscriptionData: any;
  displayedColumns: string[] = ['subscriptionId', 'subscriptionName', 'dataZone'];
  subscriptionTable: any = [];

  dataSource: any;
  showNoSubscription: any;
  showSpinner: any;
  searchSolutionText: any;
  dropdownsList: any = [];
  dashboardLink: any;
  susbcriptionLink: any;
  pageSize: number;
  pageNumber = 1;

  paginationSize = 10;
  pageIndex = 0;
  showPagination = true;
  sortInfo: any;
  tenantList: any;
  tenantId: any;
  filteredColumns: any;
  clearData: boolean;
  subscription: Subscription;
  SubscriptionTypes = SubscriptionTypes;
  selectedDefaultFilter: any;
  tenantData: any = [];
  subscriptionId: any;
  data: any;
  subscriptionDataId: any;
  subscriptionIdPii: any;
  subscriptionNamePii: any;
  subDataZonePii: any;
  subscriptionIdNonPii: any;
  subscriptionNameNonPii: any;
  subDataZoneNonPii: any;
  accountIdNonProdPii: any;
  accountNameNonProdPii: any;
  accountEmailNonProdPii: any;
  accDataZoneNonProdPii: any;
  accountIdNonPii: any;
  accountNameNonPii: any;
  accountEmailNonPii: any;
  accDataZoneNonPii: any;
  accountIdProdPii: any;
  accountNameProdPii: any;
  accountEmailProdPii: any;
  accDataZoneProdPii: any;
  DeployStatusPii: boolean;
  DeployStatusNonPii: boolean;
  DeployStatusNonProdPii: boolean;
  DeployStatusProdPii: boolean;
  subscriptionCount = 0;
  isLoading: boolean;
  copy = false;
  tenantDetailsData: any;
  permissionsMap: { [key: string]: boolean };
  Permissions = Permissions;
  PermissionKeys = PermissionKeys;

  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router,
    private sidenavService: SidenavService, private toastrService: CustomToastrService, private tenantService: TenantService,
    public dateTimeFormatService: DateTimeFormatService, private permissionsService: PermissionsService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.sidenavService.tenantSelectedMenu = 'LEFT_SIDE_NAV.SUBSCRIPTION';
    this.tenantId = this.route.snapshot.params.id;
    if (!this.permissionsMap[PermissionKeys.TENANT_READ]) {
      this.router.navigate(['/', this.tenantId, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.dashboardLink = ({ label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING') });
    this.susbcriptionLink = ({ label: translate('LEFT_SIDE_NAV.SUBSCRIPTION'), url: ['subscription'] });
    if(this.tenantId) {
      this.isLoading = true;
      this.getSubsciptionData(this.tenantId, this.searchSolutionText, this.pageSize);
      this.loadData(this.tenantId);
    }
    this.dropdownsList = [
      {
        title: 'Tenant',
        placeholder: translate('INSTANCE_LIST.SELECT_TENANT'),
        key: 'tenant',
        options: []
      },
    ];

    this.clearData = true;
    this.tenant = this.authService.principal.provider;
    this.getTenants();
    this.showNoSubscription = true;
  }

  /**
   * Getting a tenant List to be displayed in filter removing all the external tenants.
   */
  getTenants(): void {
    this.dropdownsList[0].options = [];
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any)=> {
        if (data) {
          data = data.filter(value => value.managementType !== 'external' && value.tenantId !== 'temenos.com');
          this.tenantList = [...new Set(data.map(item => item.tenantId).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
          this.tenantList.forEach((value) => {
            this.dropdownsList[0].options.push({ value, selected: false });
          });
        }
      });
  }

  getSubsciptionData(tenantId?, solutionId?, pageSize?, pageNumber?): void {
    this.isLoading = true;
    if (tenantId) {
      localStorage.setItem('filteredTenantSubscription', tenantId);
    } else {
      localStorage.removeItem('filteredTenantSubscription');
    }
    this.tenantService.getTenantDetails(this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.tenantDetailsData = data;
    });
    this.loadData(this.susbscriptionData);
    this.tenantService.getTenantAccountDetails(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.subscriptionTable = [];
        if (data) {
          this.isLoading = false;
          this.showNoSubscription = false;
          this.susbscriptionData = [];
          const zones = [];
          this.subscriptionId = data;
        }
      },
        (error) => {
          this.isLoading = false;
          this.showNoSubscription = true;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
  }

  loadData(data?): void {
    this.pageIndex = 0;
    if (this.sortInfo) {
      const sortedData = this.sortInstanceData(this.sortInfo);
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      this.dataSource = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    }
  }

  sortData(event): void {
    this.sortInfo = event;
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.subscriptionTable.data = this.sortInstanceData(event);
    this.dataSource = new MatTableDataSource(this.subscriptionTable.data?.slice(this.pageIndex, this.paginationSize));
  }

  sortInstanceData(event): any {
    return this.subscriptionTable.data?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'subscriptionId':
          comparatorResult = a?.subscriptionId && b?.subscriptionId ? a?.subscriptionId?.localeCompare(b?.subscriptionId) : !a?.subscriptionId ? -1 : 1;
          break;
        case 'subscriptionName':
          comparatorResult = a?.subscriptionName && b?.subscriptionName ? a?.subscriptionName?.localeCompare(b?.subscriptionName) : !a?.subscriptionName ? -1 : 1;
          break;
        case 'dataZone':
          comparatorResult = a?.dataZone && b?.dataZone ? a?.dataZone?.localeCompare(b?.dataZone)
            : !a?.dataZone ? -1 : 1;
          break;
        default:
          comparatorResult = a?.subscriptionId && b?.subscriptionId ? a?.subscriptionId?.localeCompare(b?.subscriptionId) : !a?.subscriptionId ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
    });
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.subscriptionTable.data.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

  closeMenu(data): void {
    this.clearData = false;
    this.showNoSubscription = true;
    this.sidenavService.searchFilter.next(data);
  }
}

